<template>
  <div class="prize cursor-pointer" @click="onClick">
    <div class="q-px-md q-py-md">
      <div class="c-image" v-if="prize.DETAIL_PICTURE?.SRC">
        <img :src="prize.DETAIL_PICTURE?.SRC"/>
      </div>
      <div class="c-name">
        {{ prize.NAME }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {toRefs} from "vue";
import {FortunePrize} from "@/gql/gen";
import {useRouter} from "vue-router";

const props = withDefaults(defineProps<{
  prize: FortunePrize
}>(), {});

const {prize} = toRefs(props)

const router = useRouter()

const onClick = () => {
  if (prize.value.PRIZE_TYPE === 'gift') {
    if (prize.value.GIFT_ELEMENT) {
      router.push('/product/' + prize.value.GIFT_ELEMENT)
    }
  } else {

  }
}

</script>

<style scoped lang="scss">

.prize {
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

</style>
